<ion-header>
  <ion-toolbar color="light">
    <ion-buttons slot="start">
      <ion-button (click)="dismiss()">
        <ion-icon name="arrow-back-circle-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-title class="ion-text-center">Solicitud de Eliminación de Cuenta</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
<form [formGroup]="deleteAccountForm" (ngSubmit)="onSubmit()">
  <ion-item>
    <ion-label position="floating">Correo electrónico</ion-label>
    <ion-input type="email" formControlName="email" required></ion-input>
  </ion-item>

  <ion-item>
    <ion-label position="floating">Motivo (opcional)</ion-label>
    <ion-select #selectReason
    interface="alert"
    [interfaceOptions]="{ cssClass: 'custom-alert-reason' }"
      formControlName="reason">
      <ion-select-option value="no_me_gusta">No me gusta la app</ion-select-option>
      <ion-select-option value="problemas_tecnicos">Problemas técnicos</ion-select-option>
      <ion-select-option value="otro">Otro, indique el motivo</ion-select-option>
    </ion-select>
    <ion-textarea *ngIf="selectReason.value == 'otro'" formControlName="other_reason" ></ion-textarea>
  </ion-item>

  <p>Para confirmar su identidad y completar su solicitud, se enviará un código a su correo electrónico.</p>

  <ion-item>
    <ion-checkbox formControlName="consent"></ion-checkbox>
    <ion-label class="ion-padding">Entiendo que al eliminar mi cuenta, perderé acceso a todos mis datos.</ion-label>
  </ion-item>

  <ion-button expand="full" color="danger" type="submit" [disabled]="!deleteAccountForm.valid">
    Eliminar mi cuenta
  </ion-button>
</form>
</ion-content>
